// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgSendIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="m20.8 10.17-16-7A2 2 0 0 0 2 5.33l.8 4.83a1 1 0 0 0 1 .84H13a1 1 0 0 1 0 2H3.82a1 1 0 0 0-1 .84L2 18.67A2 2 0 0 0 4 21c.275-.002.548-.06.8-.17l16-7a2 2 0 0 0 0-3.66" />
  </g>
);
export default SvgSendIcon;
SvgSendIcon.displayName = 'SvgSendIcon';
